import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Palette, ShoppingCart, FileText, RefreshCw, Search, Settings } from 'lucide-react';

const Services = () => {
  const { t } = useLanguage();

  const services = [
    { icon: Palette, titleKey: 'services.webDesign', descKey: 'services.webDesignDesc' },
    { icon: ShoppingCart, titleKey: 'services.ecommerce', descKey: 'services.ecommerceDesc' },
    { icon: FileText, titleKey: 'services.landingPages', descKey: 'services.landingPagesDesc' },
    { icon: RefreshCw, titleKey: 'services.redesign', descKey: 'services.redesignDesc' },
    { icon: Search, titleKey: 'services.seo', descKey: 'services.seoDesc' },
    { icon: Settings, titleKey: 'services.maintenance', descKey: 'services.maintenanceDesc' },
  ];

  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 md:py-32 bg-black"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center mb-6">
            <div className="h-px w-8 bg-[#B8860B]"></div>
            <span className="mx-3 text-[#B8860B] text-xs tracking-[0.2em] uppercase">{t('nav.services')}</span>
            <div className="h-px w-8 bg-[#B8860B]"></div>
          </div>
          <h2
            data-testid="services-title"
            className="font-outfit text-3xl sm:text-4xl lg:text-5xl font-light text-white tracking-tight"
          >
            {t('services.title')}
          </h2>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group p-8 bg-[#0A0A0A] border border-white/10 rounded-xl transition-all duration-300 hover:border-[#B8860B]/50 hover:-translate-y-1 hover:shadow-[0_8px_30px_rgba(184,134,11,0.1)]"
              data-testid={`service-card-${index}`}
            >
              <div className="mb-6">
                <service.icon
                  size={32}
                  strokeWidth={1.5}
                  className="text-[#B8860B]"
                />
              </div>
              <h3 className="font-outfit text-xl font-medium text-white mb-3">
                {t(service.titleKey)}
              </h3>
              <p className="text-[#A1A1AA] text-sm leading-relaxed">
                {t(service.descKey)}
              </p>
              <div className="mt-6 h-px w-0 bg-[#B8860B] group-hover:w-12 transition-all duration-300"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
